import { marketplaceRestrictionsEpics } from './marketplaceRestrictions/marketplaceRestrictions.epics';

export const giftInvitesEpics = [...marketplaceRestrictionsEpics];
